import React from 'react'
import { Deal } from '@services/deals/types/deal';
import { Translate } from 'react-localize-redux';
import { useTheme } from 'styled-components';
import Typography from '../../../../../components/basics/typography';
import DineroFactory, { DineroObject } from 'dinero.js';
import { DealSummaryGrid, DealSummaryTitle } from '../components';

interface LabelDealsSummaryCtrlProps {
  className?: string;
  deals: Deal[];
}

const zeroAmount: DineroObject = {amount: 0, precision: 2, currency: 'USD'};

export const LabelDealsSummaryCtrl: React.FC<LabelDealsSummaryCtrlProps> = ({ className, deals }) => {
  const theme = useTheme();

  const revenue = deals.reduce((m, d) => m.add(d.revenue), DineroFactory(zeroAmount))
  const labels = deals.reduce((m, d) => m + (d.labels?.length || 0), 0);
  const artists = deals.reduce((m, d) => m + d.artistCount, 0);

  return (
    <DealSummaryGrid className={className }>
      <section>
        <DealSummaryTitle type="small" customFont="semi-bold" color={theme.colors.tertiary} uppercase>
          <Translate id="LABEL.DEALS.SUMMARY.LABELS.REVENUE" />
        </DealSummaryTitle>
        <Typography customFont="semi-bold" type="section-title-preview">
          {revenue.toFormat()}
        </Typography>
      </section>
      <section>
        <DealSummaryTitle type="small" customFont="semi-bold" color={theme.colors.tertiary} uppercase>
          <Translate id="LABEL.DEALS.SUMMARY.LABELS.COUNT" />
        </DealSummaryTitle>
        <Typography customFont="semi-bold" type="section-title-preview">
          {labels}
        </Typography>
      </section>
      <section>
        <DealSummaryTitle type="small" customFont="semi-bold" color={theme.colors.tertiary} uppercase>
          <Translate id="LABEL.DEALS.SUMMARY.LABELS.ARTISTS" />
        </DealSummaryTitle>
        <Typography customFont="semi-bold" type="section-title-preview">
          {artists}
        </Typography>
      </section>
    </DealSummaryGrid>
  )
}
